const bizCodesObjectKey = "Biz-Codes";
const bizCodeCurrentObjectKey = "Current-Biz-Code";

export function getBizCodesObject() {
  return JSON.parse(localStorage.getItem(bizCodesObjectKey));
}

export function setBizCodesObject(bizCodes) {
  localStorage.setItem(bizCodesObjectKey, JSON.stringify(bizCodes));
}

export function getCurrentBizCode() {
  return sessionStorage.getItem(bizCodeCurrentObjectKey);
}

export function setCurrentBizCode(currentBizCode) {
  sessionStorage.setItem(bizCodeCurrentObjectKey, currentBizCode);
}
